export enum ActiveShiftTabEnum {
  Today = 'today',
  PendingReview = 'pending-review',
  BidFeedback = 'bid-feedback',
}
